export function clearEmptyObjects(array) {
  array.forEach((item) => {
    Object.keys(item).length === 0 && array.splice(array.indexOf(item), 1);
  });
  return array;
}

export function arrayContainCheck(array, object) {
  return array.some(obj => obj.inn === object.inn);
}

export function formatNumberWithSpaces(number) {
  return number.toLocaleString('ru-RU');
}
